import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router";
import { useCurrentUser } from "@/features/auth/api";

/**
 * Route guard for the signed-in area. The API enforces access on every request;
 * this only decides what to render (ADR-0008).
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const location = useLocation();
  const me = useCurrentUser();

  if (me.isPending) {
    return (
      <div role="status" className="flex min-h-dvh items-center justify-center text-fg-muted">
        {t("app.loading")}
      </div>
    );
  }
  if (!me.data) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  return <>{children}</>;
}
